module.exports = __webpack_public_path__ + "img/symbol_0.752f5700.png";